import React, { useEffect, useState } from "react";
import { DatePicker, Select, Button, Upload, message, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../redux/ReconAndSettlement/actions";
import DnD from "./Dnd";
import "./index.scss";
import moment from "moment";

const { Option } = Select;
const { RangePicker } = DatePicker;
const { getReconData, getReconDataReset, getReconDataNotified } = actions;

const Filter = ({ selectedFile, setSelectedFile, loading}) => {
  const dispatch = useDispatch();
  const [messageApi, contextHolder] = message.useMessage();
  const [dropdown1Value, setDropdown1Value] = useState(null);
  const [dateRange, setDateRange] = useState({fromDate : "", toDate : ""});

  const { fetchReconData } = useSelector((state) => ({
    fetchReconData: state.reconReducer?.fetchReconData,
  }));

  const handleDropdown1Change = (value) => setDropdown1Value(value);

  const handleDateChange = (dates) => {
    // console.log(dates , "dates");
    if (dates && dates.length === 2) {
      setDateRange({fromDate:dates[0], toDate:dates[1]}); 
    } else {
      setDateRange([]);
    }
  };



  const handleFormSubmit = () => {
    // console.log(dateRange , "datreRange in handleFormSubmit");
    if (dropdown1Value && dateRange.fromDate && dateRange.toDate) {
      const formattedStartDate = moment(dateRange?.fromDate['$d']).format("YYYY-MM-DDTHH:mm:ss%2B05:30");
      const formattedEndDate = moment(dateRange?.toDate['$d']).format("YYYY-MM-DDTHH:mm:ss%2B05:30");
  
      // console.log("Start Date:", formattedStartDate);
      // console.log("End Date:", formattedEndDate);
  
      const fileData = {
        fileType: dropdown1Value,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
      };
  
      setSelectedFile(fileData);  // Setting state asynchronously

      dispatch(getReconData(fileData));  // Dispatch API call immediately
    } else {
      message.warning("Please fill in all fields.");
    }
  };
  

  useEffect(() => {
    if (fetchReconData?.loading === true && fetchReconData?.error === null) {
      messageApi.destroy();
      // messageApi.open({ type: "loading", content: "Fetching..." });
    } else if (
      fetchReconData?.error !== null &&
      !fetchReconData?.data?.message?.length > 0 &&
      fetchReconData?.loading === false
    ) {
      messageApi.destroy();
      messageApi
        .open({ type: "error", content: fetchReconData?.error, duration: 1 })
        .then(() => dispatch(getReconDataReset()));
    } else if (
      fetchReconData?.data?.message?.length > 0 &&
      fetchReconData?.error === null &&
      fetchReconData?.loading === false &&
      fetchReconData?.notified === false
    ) {
      messageApi.destroy();
      // messageApi
      //   .open({
      //     type: fetchReconData?.data?.url?.length > 0 ? "success" : "info",
      //     content: fetchReconData?.data?.message,
      //     duration: 1,
      //   })
      //   .then(() => dispatch(getReconDataNotified()));
    }
  }, [fetchReconData]);

  return (
    <div className="filter-container">
      {contextHolder}

      {/* {showForm ? ( */}
      <div className="form-container">
        <Select
          placeholder="Select File Type"
          className="filter-select"
          onChange={handleDropdown1Change}
        >
          <Option value="xml">XML File</Option>
          <Option value="json">JSON File</Option>
          {/* <Option value="match">MATCH File</Option> */}
          <Option value="csv">CSV File</Option>
          <Option value="transactionFile">Transaction Report</Option>
        </Select>

        {/* <Select placeholder="Select Cycle No." className="filter-select" onChange={handleDropdown2Change}>
            {[...Array(8)].map((_, i) => (
              <Option key={i} value={i + 1}>Cycle {i + 1}</Option>
            ))}
          </Select> */}

        {/* if we want to show time with this date picker input filed then we can use this keyword in this showTime */}

        <RangePicker
          className="filter-date-picker"
          showTime
          onChange={handleDateChange}
          placeholder={["Start Date", "End Date"]}
        />

        <Button onClick={handleFormSubmit} className="filter-button">
          {loading ? <Spin size="20" /> : "Submit"}
        </Button>
      </div>
      {/* ) */}
      {/* : ( */}
      {/* <div className="upload-container">
          <Upload>
            <DnD setFormDataState={setFile} />
          </Upload>
        </div> */}
      {/* )} */}
    </div>
  );
};

export default Filter;
